<template>
  <div>
    <el-row :gutter="20">
      <el-form label-width="80px"
               :inline="true"
               :model="reportForm">

        <el-form-item label="报告时间">
          <el-date-picker v-model="reportForm.dateStr"
                          @change="getReportList(1)">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="股票选择">
          <el-select :popper-append-to-body=false
                     clearable
                     @change="getReportList(1)"
                     v-model="reportForm.codes"
                     value-key="ts_code"
                     filterable
                     remote
                     :remote-method="searchStock"
                     default-first-option
                     placeholder="请输入股票名称或股票代码">

            <el-option v-for="(item,index) in options"
                       :key="index"
                       :label="item.name"
                       :value="item.symbol">
            </el-option>

          </el-select>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row>
          <el-table v-loading="tableLoading"
                    :data="pageInfo.records"
                    style="width: 100%">

            <el-table-column prop="names"
                             label="股票名称">
            </el-table-column>
            <el-table-column prop="codes"
                             label="股票代码">
            </el-table-column>

            <el-table-column prop="fileType"
                             label="文件类型">
            </el-table-column>
            <el-table-column prop="dateStr"
                             label="日期">
            </el-table-column>
            <el-table-column label="文件url">
              <template slot-scope="scope">
                <el-link :href="scope.row.url"
                         target="_blank"
                         :underline="false"> {{scope.row.url}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                {{scope.row.status | statusFilter}}
              </template>
            </el-table-column>
            <el-table-column fixed="right"
                             label="操作">
              <template slot-scope="scope">
                <el-button type="text"
                           size="small"
                           @click="readReport(scope.row)">阅读</el-button>
                <el-button type="text"
                           size="small"
                           @click="dopwnloadReport(scope.row)">下载</el-button>
              </template>
            </el-table-column>

          </el-table>
        </el-row>
        <el-row>
          <el-pagination background
                         layout="total,prev, pager, next"
                         @current-change="getReportList"
                         :total="pageInfo.total">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
export default {
  name: 'myReports',
  data: function () {
    return {
      tableLoading: true,
      pageInfo: {
        current: 1,
        size: 5,
        records: [],
        total: 1
      },

      reportForm: {
        dateStr: new Date()
      },

      sourceId: '',
      activeName: 'price',
      userForm: {
        name: '',
        id: '',
        mobile: '',
        status: 'ENABLE'
      },
      userRules: {},
      optType: 'user',

      reportPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },
      curUserId: '',
      prices: [],
      accountForm: {},
      accountRule: {},
      accountTime: 0,

      taskDialogVisible: false,
      taskForm: {
        type: 'FULL'
      },
      options: [],
      candidateOptions: [],
      conceptOptions: [],
      candidateConcept: [],

      // 学校列表
      schoolPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },

      schoolFrom: {
        refresh: false
      },

      proxyList: [],
      pricePageInfo: {
        page: 1,
        size: 10
      },
      curAddPrice: null,
      priceTable: []
    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },

    reportTypeFilter: function (v) {
      switch (v) {
        case 'ALL':
          return '所有'
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'COMPARE':
          return '投资组合'
        case 'FINANCE':
          return '财务报告'
        case 'HKSTOCK':
          return '香港个股'
        default:
          break
      }
      return v
    },
    statusFilter: function (v) {
      switch (v) {
        case 'FAIL':
          return '失败'
        case 'FINISH':
          return '完成'
        case 'DOING':
          return '生成中'
        default:
          return v
      }
    },
    fileTypeFilter: function (v) {
      switch (v) {
        case 'PDF':
          return 'PDF'
        case 'DOC':
          return 'WORD'
        case 'ALL':
          return '所有'

        default:
          return v
      }
    },
    rolesTypeFilter: function (v) {
      switch (v) {
        case 'ADMIN':
          return '管理员'
        case 'NORMAL':
          return '注册用户'
        case 'VIP':
          return 'VIP用户'
        case 'SVIP':
          return '超级VIP'
        default:
          return v
      }
    }
  },
  methods: {
    readReport (row) {

    },
    searchStock (query) {
      this.searchLabel = '搜索结果'
      query = query.trim()
      if (query) {
        let _this = this
        setTimeout(() => {
          _this.options = _this.candidateOptions.filter(item => {
            return ((item.name.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
              (item.ts_code.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
              ((item.pinyin || '').toLowerCase().indexOf(query.toLowerCase()) > -1))
          })
        }, 200)
      } else {
        this.options = this.searchLogs
      }
    },
    getReportList (i) {
      let _this = this

      let codes = ''
      if (this.reportForm.codes) {
        codes = this.reportForm.codes
      }
      let dateStr = ''
      if (this.reportForm.dateStr) {
        dateStr = moment(this.reportForm.dateStr).format('YYYYMMDD')
      }
      axios.get('/api/web/admin/autoReports?page=' + i + '&dateStr=' + dateStr +
        '&codes=' + codes
      ).then(resp => {
        _this.tableLoading = false
        _this.pageInfo = resp.data
        _this.pageInfo.total = parseInt(resp.data.total)
      })
    }
  },
  components: {

  },
  mounted () {
    this.getReportList(1)
    let _this = this
    try {
      this.candidateOptions = JSON.parse(localStorage.getItem('candidateOptions'))
    } catch (e) { }
    axios.get('/api/web/stock/list').then(resp => {
      _this.candidateOptions = resp.data
      localStorage.setItem('candidateOptions', JSON.stringify(_this.candidateOptions))
      _this.loading = false
    })
  },
  watch: {

  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/autoReport.vue